export const visit = (vm, at) => {
vm(require("foundations-components/lang/pt-pt.lyaml"));
at({ "pt-pt": { "placeholder": "marcador de posi\xE7\xE3o" } });
};